
import React from "react";
import TimesEditorMain from "./times/TimesEditorMain";

interface TimesEditorProps {
  content?: any;
  onContentChange?: (field: string, value: any) => void;
}

const TimesEditor: React.FC<TimesEditorProps> = ({ content, onContentChange }) => {
  return <TimesEditorMain content={content} onContentChange={onContentChange} />;
};

export default TimesEditor;
